var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSucess = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_7338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.700012,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_7338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3 17.1L18.35 10.05L16.95 8.65L11.3 14.3L8.45001 11.45L7.05001 12.85L11.3 17.1ZM12.7 22.5C11.3167 22.5 10.0167 22.2375 8.80001 21.7125C7.58335 21.1875 6.52501 20.475 5.62501 19.575C4.72501 18.675 4.01251 17.6167 3.48751 16.4C2.96251 15.1833 2.70001 13.8833 2.70001 12.5C2.70001 11.1167 2.96251 9.81667 3.48751 8.6C4.01251 7.38333 4.72501 6.325 5.62501 5.425C6.52501 4.525 7.58335 3.8125 8.80001 3.2875C10.0167 2.7625 11.3167 2.5 12.7 2.5C14.0833 2.5 15.3833 2.7625 16.6 3.2875C17.8167 3.8125 18.875 4.525 19.775 5.425C20.675 6.325 21.3875 7.38333 21.9125 8.6C22.4375 9.81667 22.7 11.1167 22.7 12.5C22.7 13.8833 22.4375 15.1833 21.9125 16.4C21.3875 17.6167 20.675 18.675 19.775 19.575C18.875 20.475 17.8167 21.1875 16.6 21.7125C15.3833 22.2375 14.0833 22.5 12.7 22.5ZM12.7 20.5C14.9333 20.5 16.825 19.725 18.375 18.175C19.925 16.625 20.7 14.7333 20.7 12.5C20.7 10.2667 19.925 8.375 18.375 6.825C16.825 5.275 14.9333 4.5 12.7 4.5C10.4667 4.5 8.57501 5.275 7.02501 6.825C5.47501 8.375 4.70001 10.2667 4.70001 12.5C4.70001 14.7333 5.47501 16.625 7.02501 18.175C8.57501 19.725 10.4667 20.5 12.7 20.5Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSucess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sucess.52b58367.svg";
export { ForwardRef as ReactComponent };